<template>
    <div class="select-container" :class="{open: isOpen, nobor: border==false}" v-on-clickaway="away">
        <div class="select-input">
            <span class="fa fa-times-circle-o cross" v-if="!isDisabled && keyWord!=''" @click="onClear"></span>
            <input type="text" class="form-control" :class="size"
                ref="input"
                :placeholder="place"
                v-model="keyWord"
                @focus="onFocus"
                @input="onInput"
                @keydown.down.prevent="moveActive(1)"
                @keydown.up.prevent="moveActive(-1)"
                @keydown.enter.prevent="selectActive"
                @keydown.esc.prevent="away"
                :disabled="isDisabled"/>
        </div>
        <div class="select-dropdown vld-parent" ref="i100" style="min-height: 30px;">
            <table class="table-select">
                <tbody>
                    <tr v-for="(ret,index) in list" :key="ret.Id || index" :class="{active: index === activeIndex}" @mousedown.prevent="select(ret)">
                        <td>{{ret.Num}}</td>
                        <td>{{ret.Name}}</td>
                    </tr>
                    <tr v-if="!isLoading && isOpen && list.length === 0">
                        <td colspan="2" class="empty-result">មិនមានទិន្នន័យ</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
    import { mixin as clickaway } from 'vue-clickaway';
    export default {
        mixins: [ clickaway ],
        props: {
            value: {
                type: String,
                default: ''
            },
            border: {
                type: Boolean,
                default: true
            },
            place: {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            },
            productType: {
                type: String,
                default: '0'
            },
            size: {
                type: String,
                default: 'form-control-sm'
            }
        },
        data: function(){
            return {
                keyWord: this.value,
                productTypeId: this.productType,
                isOpen: false,
                list: [],
                isDisabled: this.disabled,
                isShow: false,
                isLoading: false,
                activeIndex: -1,
                searchTimer: null,
                lastQueryKey: '',
                requestId: 0,
                loadingInstance: null
            }
        },
        methods: {
            onInput(){
                this.$emit('input', this.keyWord);
                this.isOpen = true;
                this.activeIndex = -1;

                clearTimeout(this.searchTimer);
                this.searchTimer = setTimeout(() => {
                    this.toList();
                }, 250);
            },
            toList(){
                if(this.isDisabled) return;

                const text = (this.keyWord || '').trim();
                const queryKey = `${text}|${this.productTypeId}`;
                if(queryKey === this.lastQueryKey && this.list.length > 0) return;

                this.lastQueryKey = queryKey;
                this.list = [];
                this.activeIndex = -1;
                this.isLoading = true;
                this.hideLoading();

                const currentRequestId = ++this.requestId;
                if(this.$refs.i100){
                    this.loadingInstance = this.$loading.show({
                        container: this.$refs.i100,
                        height: 25,
                        loader: 'dots'
                    });
                }

                this.$api().post('item/0/list', { Text: text, ProductTypeId: this.productTypeId }).then(res => {
                    if(currentRequestId !== this.requestId) return;
                    if(this.$isValid(res)){
                        this.list = res.data.Json.Items || [];
                        this.isShow = true;
                        this.activeIndex = this.list.length > 0 ? 0 : -1;
                    }
                }).finally(() => {
                    if(currentRequestId === this.requestId){
                        this.isLoading = false;
                        this.hideLoading();
                    }
                });
            },
            onFocus(){
                if(this.isDisabled) return;
                this.isOpen = true;
                const queryKey = `${(this.keyWord || '').trim()}|${this.productTypeId}`;
                if(!this.isShow || this.lastQueryKey !== queryKey) this.toList();
            },
            away() {
                this.isOpen = false;
                this.activeIndex = -1;
            },
            select(item){
                if(!item) return;
                this.keyWord = item.Name;
                this.isOpen = false;
                this.activeIndex = -1;
                this.$emit('input', item.Name);
                this.$emit('select', item);
            },
            onClear(){
                clearTimeout(this.searchTimer);
                this.keyWord = '';
                this.list = [];
                this.activeIndex = -1;
                this.lastQueryKey = '';
                this.$emit('input', '');
                this.$emit('clear');
                this.$nextTick(() => {
                    this.$refs.input.focus();
                });
            },
            moveActive(step){
                if(!this.isOpen || this.list.length === 0) return;

                const lastIndex = this.list.length - 1;
                if(this.activeIndex < 0){
                    this.activeIndex = step > 0 ? 0 : lastIndex;
                    return;
                }

                const nextIndex = this.activeIndex + step;
                if(nextIndex < 0){
                    this.activeIndex = lastIndex;
                } else if(nextIndex > lastIndex){
                    this.activeIndex = 0;
                } else {
                    this.activeIndex = nextIndex;
                }
            },
            selectActive(){
                if(!this.isOpen){
                    this.onFocus();
                    return;
                }

                if(this.activeIndex >= 0 && this.list[this.activeIndex]){
                    this.select(this.list[this.activeIndex]);
                    return;
                }

                this.toList();
            },
            hideLoading(){
                if(this.loadingInstance){
                    this.loadingInstance.hide();
                    this.loadingInstance = null;
                }
            }
        },
        watch: {
            value(val){
                this.keyWord = val || '';
            },
            disabled(value){
                this.isDisabled = value;
            },
            productType(value){
                this.productTypeId = value;
                this.lastQueryKey = '';
                if(this.isOpen) this.toList();
            }
        },
        beforeDestroy(){
            clearTimeout(this.searchTimer);
            this.requestId += 1;
            this.hideLoading();
        }
    }
</script>
<style scoped>
    .select-container {
        position: relative;
    }

    .select-input {
        position: relative;
    }

    .cross {
        color: #6c757d;
        cursor: pointer;
        position: absolute;
        right: 8px;
        top: 50%;
        transform: translateY(-50%);
        z-index: 2;
    }

    .select-dropdown {
        background: #fff;
        border: 1px solid #cfe0f3;
        border-radius: 4px;
        box-shadow: 0 8px 18px rgba(8, 86, 171, 0.14);
        display: none;
        left: 0;
        max-height: 280px;
        overflow: auto;
        position: absolute;
        right: 0;
        top: calc(100% + 2px);
        z-index: 30;
    }

    .open .select-dropdown {
        display: block;
    }

    .table-select {
        margin-bottom: 0;
        width: 100%;
    }

    .table-select td {
        border: 0;
        padding: 6px 8px;
        vertical-align: middle;
    }

    .table-select tr {
        cursor: pointer;
    }

    .table-select tr:hover,
    .table-select tr.active {
        background: #edf6ff;
    }

    .empty-result {
        color: #6c757d;
        cursor: default;
        text-align: center;
    }

    .nobor .form-control {
        border: 0;
    }
</style>
